<template>
    <div>
      <div elevation="0" color="transparent" flat>
        <div class="row mb-8">
          <div class="col-6 d-flex justify-content-start">
            <v-card-title>
              {{ $t('masterOrders.MasterOrderDetails.docTitle') }}
            </v-card-title>
          </div>
          
         
        </div>
      </div>

   
      <v-card elevation="0">
        <MasterOrderDetails :masterOrderId="masterOrderId" />
      </v-card>
    </div>
  </template>
  
  <script>
import MasterOrderDetails from "./MasterOrderDetails.vue";

  
  export default {
    components: {
        MasterOrderDetails,
    },
    data() {
        return {
            masterOrderId: null,
        };
    },
    created() {
        this.masterOrderId = this.$route.params.id;
    },
    mounted() {
      document.title = window.VUE_APP_NAME + ' - ' + this.$t('masterOrders.docTitle');
    },
  };
  </script>
  
  <style scoped>
  .v-card-title {
    color: #001e50;
    font-size: 18px;
    line-height: 25.5px;
    font-weight: 700;
    font-family: inter;
  }
  </style>